import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import clsx from 'clsx'
import React from 'react'

export const documentHeading1: NodeRenderer = (node, children) => (
  <p
    className={clsx(
      'align-center text-200 font-medium leading-alternate text-white-50',
      'tablet:text-230'
    )}
  >
    {children}
  </p>
)
